import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./How_We_Work.css";
import CommonHeading from "../../Common_Components/Common_Heading/Common_Heading";

const workSteps = [
  {
    number: "1",
    title: "Initial Consultation",
    description:
      "Meet with our expert consultants to discuss your career goals, skills, and job preferences for overseas placement.",
  },
  {
    number: "2",
    title: "Document Submission",
    description:
      "Provide all necessary documents including passport, certificates, and experience letters for verification.",
  },
  {
    number: "3",
    title: "Skill Assessment",
    description:
      "We conduct interviews, language tests, and skill assessments to ensure you're a perfect match.",
  },
  {
    number: "4",
    title: "Job Matching",
    description:
      "We match you with verified employers offering the best opportunities that suit your profile.",
  },
  {
    number: "5",
    title: "Job Offer",
    description:
      "Receive official job offer from international employer with competitive salary and benefits package.",
  },
  {
    number: "6",
    title: "Visa Processing",
    description:
      "Complete visa application with our full support and guidance through every step of the process.",
  },
  {
    number: "7",
    title: "Pre-Departure Training",
    description:
      "Receive orientation and training on workplace culture, safety, and lifestyle in destination country.",
  },
  {
    number: "8",
    title: "Post-Placement Support",
    description:
      "Ongoing support after placement to ensure successful integration and quick issue resolution.",
  },
];

const HowWeWork = () => {
  return (
    <section className="how_we_work">
      <Container>
        <div className="how_we_work_heading">
          <CommonHeading
            badge="steps"
            title="How We Work"
            description="8 transparent steps from application to placement ."
          />
        </div>

        <Row className="g-3">
          {workSteps.map((step) => (
            <Col key={step.number} xs={12} sm={6} lg={3}>
              <div className="how_we_work_card">
                <div className="how_we_work_num">{step.number}</div>

                <div className="how_we_work_content">
                  <h3 className="how_we_work_title">{step.title}</h3>

                  <p className="how_we_work_text">{step.description}</p>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default HowWeWork;
